module.exports = __webpack_public_path__ + "assets/agape-ico-pickdate.b9b22d83.svg";